/** Scale image via canvas drawImage with smoothing */
export function resizeImageData(source: ImageData, newWidth: number, newHeight: number): ImageData {
  newWidth = Math.max(1, Math.round(newWidth));
  newHeight = Math.max(1, Math.round(newHeight));

  // Draw source onto offscreen canvas
  const srcCanvas = new OffscreenCanvas(source.width, source.height);
  const srcCtx = srcCanvas.getContext('2d')!;
  srcCtx.putImageData(source, 0, 0);

  // Draw scaled onto destination canvas
  const dstCanvas = new OffscreenCanvas(newWidth, newHeight);
  const dstCtx = dstCanvas.getContext('2d')!;
  dstCtx.imageSmoothingEnabled = true;
  dstCtx.imageSmoothingQuality = 'high';
  dstCtx.drawImage(srcCanvas, 0, 0, newWidth, newHeight);

  return dstCtx.getImageData(0, 0, newWidth, newHeight);
}
